export default {
  isShown: (state) => state.isShown,
};
